import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { supabase } from '../lib/supabase';

const TIMEOUT = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
const ACTIVITY_EVENTS = ['mousedown', 'keydown', 'touchstart', 'mousemove'];

export function useSession() {
  const { user } = useAuth();

  useEffect(() => {
    if (!user) return;

    let timeout: number;
    let lastActivity = Date.now();

    const resetTimeout = () => {
      clearTimeout(timeout);
      lastActivity = Date.now();
      timeout = window.setTimeout(handleInactivity, TIMEOUT);
    };

    const handleActivity = () => {
      const now = Date.now();
      if (now - lastActivity >= TIMEOUT) {
        handleInactivity();
      } else {
        resetTimeout();
      }
    };

    const handleInactivity = async () => {
      await supabase.auth.signOut();
      window.location.href = '/';
    };

    // Set up activity listeners
    ACTIVITY_EVENTS.forEach(event => {
      document.addEventListener(event, handleActivity);
    });

    // Initial timeout
    resetTimeout();

    return () => {
      clearTimeout(timeout);
      ACTIVITY_EVENTS.forEach(event => {
        document.removeEventListener(event, handleActivity);
      });
    };
  }, [user]);
}